export const AUTH_CONFIG = {
    domain: 'serengeti-dizalica.eu.auth0.com',
    clientId: 't7VdDnu4qVCXZoRYoxZJJPufO22qBOlU',
    //callbackUrl: 'http://localhost:3000/callback'
    callbackUrl: 'https://dizalica-e579e.firebaseapp.com/callback'
  }